import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Tabs } from "@shared/ui/tabs";
import { ConsumerDistributionView } from "../dashboard/ConsumerDistributionView";
import { DistributionTab } from "../dashboard/DistributionTab";
import { PrintingTab } from "../dashboard/PrintingTab";
import { PageHeader } from "@shared/components/PageHeader";

const Index = () => {
  const [viewMode, setViewMode] = useState<"cycle" | "consumer">("cycle");
  const [selectedCycle, setSelectedCycle] = useState<string | null>(null);

  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      setViewMode("consumer");
    } else {
      setViewMode("cycle");
    }
  }, [id]);

  const handleBackToCycle = () => {
    setViewMode("cycle");
    setSelectedCycle(null);
    navigate(`/bx/printing-distribution?tab=distribution`);
  };

  const handleCycleSelect = (cycle: any) => {
    setSelectedCycle(cycle);
    setViewMode("consumer");
  };

  return (
    <div className="space-y-8">
      <div className="space-y-6">
        <PageHeader
          title="Printing & Distribution Dashboard"
          subtitle="Manage print jobs and distribution across all channels"
        />
        <div className="flex flex-col space-y-4">
          <div className="w-full overflow-hidden">
            <Tabs
              defaultValue="printing"
              className="w-full"
              tabsListClassName="grid w-full grid-cols-2 mb-6 p-1"
              urlMapping={{
                printing: "printing",
                distribution: "distribution",
              }}
              tabComponents={{
                printing: {
                  label: "Printing",
                  component: <PrintingTab />,
                },
                distribution: {
                  label: "Distribution",
                  component: (
                    <DistributionTab onCycleSelect={handleCycleSelect} />
                  ),
                },
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
